module.exports = __webpack_public_path__ + "static/media/icon-tooltip.63884c04.svg";